import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogs = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 10.0001C10 9.53984 10.3731 9.16675 10.8333 9.16675H17.5C17.9602 9.16675 18.3333 9.53984 18.3333 10.0001C18.3333 10.4603 17.9602 10.8334 17.5 10.8334H10.8333C10.3731 10.8334 10 10.4603 10 10.0001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 15.0001C10 14.5398 10.3731 14.1667 10.8333 14.1667H17.5C17.9602 14.1667 18.3333 14.5398 18.3333 15.0001C18.3333 15.4603 17.9602 15.8334 17.5 15.8334H10.8333C10.3731 15.8334 10 15.4603 10 15.0001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 5.00008C10 4.53984 10.3731 4.16675 10.8333 4.16675H17.5C17.9602 4.16675 18.3333 4.53984 18.3333 5.00008C18.3333 5.46032 17.9602 5.83342 17.5 5.83342H10.8333C10.3731 5.83342 10 5.46032 10 5.00008Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.66675 10.0001C1.66675 9.53984 2.03984 9.16675 2.50008 9.16675H3.33341C3.79365 9.16675 4.16675 9.53984 4.16675 10.0001C4.16675 10.4603 3.79365 10.8334 3.33341 10.8334H2.50008C2.03984 10.8334 1.66675 10.4603 1.66675 10.0001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.66675 15.0001C1.66675 14.5398 2.03984 14.1667 2.50008 14.1667H3.33341C3.79365 14.1667 4.16675 14.5398 4.16675 15.0001C4.16675 15.4603 3.79365 15.8334 3.33341 15.8334H2.50008C2.03984 15.8334 1.66675 15.4603 1.66675 15.0001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.66675 5.00008C1.66675 4.53984 2.03984 4.16675 2.50008 4.16675H3.33341C3.79365 4.16675 4.16675 4.53984 4.16675 5.00008C4.16675 5.46032 3.79365 5.83342 3.33341 5.83342H2.50008C2.03984 5.83342 1.66675 5.46032 1.66675 5.00008Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83325 10.0001C5.83325 9.53984 6.20635 9.16675 6.66659 9.16675H7.49992C7.96016 9.16675 8.33325 9.53984 8.33325 10.0001C8.33325 10.4603 7.96016 10.8334 7.49992 10.8334H6.66659C6.20635 10.8334 5.83325 10.4603 5.83325 10.0001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83325 15.0001C5.83325 14.5398 6.20635 14.1667 6.66659 14.1667H7.49992C7.96016 14.1667 8.33325 14.5398 8.33325 15.0001C8.33325 15.4603 7.96016 15.8334 7.49992 15.8334H6.66659C6.20635 15.8334 5.83325 15.4603 5.83325 15.0001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83325 5.00008C5.83325 4.53984 6.20635 4.16675 6.66659 4.16675H7.49992C7.96016 4.16675 8.33325 4.53984 8.33325 5.00008C8.33325 5.46032 7.96016 5.83342 7.49992 5.83342H6.66659C6.20635 5.83342 5.83325 5.46032 5.83325 5.00008Z"
		})
	]
});
const ForwardRef = forwardRef(SvgLogs);
export default ForwardRef;
